// features/findings/charts/magnitude-bars.js
// Single-side horizontal bar chart sorted by magnitude.
// Used for Form 5 lever-magnitude rankings + similar single-axis comparisons.

export function MagnitudeBars({ title, items, valueLabel = 'magnitude' }) {
  if (!items || items.length === 0) return null;

  const sorted = [...items].sort((a, b) => Math.abs(b.value) - Math.abs(a.value));
  const max = Math.max(1, ...sorted.map((it) => Math.abs(it.value)));

  const W = 820;
  const rowH = 44;
  const H = 40 + sorted.length * rowH;
  const ML = 380;
  const MR = 80;
  const MT = 16;
  const innerW = W - ML - MR;

  return (
    <figure className="finding-chart">
      <figcaption className="finding-chart-caption">{title}</figcaption>
      <div className="finding-svg-wrap">
        <svg viewBox={`0 0 ${W} ${H}`} className="finding-svg" role="img" aria-label={title}>
          {/* Axis */}
          <line x1={ML} y1={MT} x2={ML} y2={H - 8} className="finding-svg-axis" />

          {sorted.map((it, i) => {
            const y = MT + i * rowH + rowH / 2;
            const w = (Math.abs(it.value) / max) * innerW;
            const tone = it.tone || 'brass';
            return (
              <g key={it.id || it.label}>
                {/* Label (left) */}
                <text x={ML - 12} y={y} className="finding-svg-axis-label finding-mag-label" textAnchor="end" dominantBaseline="middle">
                  {it.label}
                </text>
                {/* Bar */}
                <rect
                  x={ML} y={y - 12}
                  width={w} height={24}
                  className={`finding-mag-bar finding-mag-bar-${tone}`}
                />
                {/* Value label (right) */}
                <text x={ML + w + 8} y={y} className="finding-svg-axis-label" textAnchor="start" dominantBaseline="middle">
                  {it.valueLabel ?? it.value}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
      <div className="finding-mag-legend">
        Bars sorted by {valueLabel}.
      </div>
    </figure>
  );
}

export default MagnitudeBars;
